module.exports = __webpack_public_path__ + "static/2-d0df6dd4cae0c230f138b122af359ecb.jpg";